import { render, staticRenderFns } from "./historicoRecente.vue?vue&type=template&id=864db006&scoped=true"
import script from "./historicoRecente.vue?vue&type=script&lang=js"
export * from "./historicoRecente.vue?vue&type=script&lang=js"
import style0 from "./historicoRecente.vue?vue&type=style&index=0&id=864db006&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864db006",
  null
  
)

export default component.exports